<app-document-viewer-page *ngIf="contractUrl"  label="Contrato" [url]="contractUrl">
</app-document-viewer-page>

